import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { sk } from 'vuetify/locale'
import 'vuetify/styles'
import { appIconSet, appIconAliases } from './icons'

// Téma podľa nového dizajnového manuálu MANIA: Ruby pre akcie, neutrálne odtiene na text, svetlé plochy.
// Stavové farby sú tmavšie odtiene doplnkových farieb manuálu, aby text na nich aj nimi prešiel kontrastom AA.
const maniaTheme = {
  dark: false,
  colors: {
    primary: '#d3004c',
    'primary-darken-1': '#a12b53',
    secondary: '#292929',
    'secondary-darken-1': '#000000',
    accent: '#fdd1d9',
    error: '#c81e1e',
    info: '#1a6f9c',
    success: '#137a5a',
    warning: '#b45309',
    background: '#f4f4f5',
    surface: '#ffffff',
    'surface-bright': '#ffffff',
    'surface-light': '#f4f4f5',
    'surface-variant': '#1d1d1f',
    'on-surface-variant': '#ffffff',
    'on-background': '#292929',
    'on-surface': '#292929',
    // Doplnkové farby značky — pre grafy a jemné akcenty (najviac 15 % plochy podľa manuálu)
    ruby: '#d3004c',
    ink: '#292929',
    muted: '#4e4e4e',
    sand: '#fbf5da',
    'brand-green': '#67c7a8',
    'brand-purple': '#b698e5',
    'brand-blue': '#66b3da',
  },
  variables: {
    'border-color': '#101010',
    'border-opacity': 0.1,
    'high-emphasis-opacity': 1,
    'medium-emphasis-opacity': 0.7,
    'disabled-opacity': 0.42,
    'hover-opacity': 0.04,
    'focus-opacity': 0.1,
    'activated-opacity': 0.1,
    'pressed-opacity': 0.14,
    'theme-overlay-multiplier': 1,
  },
}

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'maniaTheme',
    themes: {
      maniaTheme,
    },
  },
  // Pod 960 px mobilná kostra (horná lišta a spodné menu), od 960 px ľavý panel.
  display: {
    mobileBreakpoint: 'md',
  },
  icons: {
    defaultSet: 'app',
    aliases: appIconAliases,
    sets: {
      app: appIconSet,
    },
  },
  locale: {
    locale: 'sk',
    messages: { sk },
  },
  defaults: {
    // Polomery (tlačidlá pilulka, karty 16 px, dialógy 24 px) rieši main.scss — trieda `rounded-*` by mala !important.
    VBtn: {
      variant: 'flat',
    },
    VCard: {
      elevation: 0,
    },
    // Vuetify dáva tlačidlám v pätičke karty variant `text`; hlavná akcia dialógu má byť plná (ako v macOS).
    // Tlačidlo bez farby ostáva vizuálne textové (biele pozadie karty), s farbou je plné.
    VCardActions: {
      VBtn: {
        variant: 'flat',
        slim: false,
      },
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      menuIcon: '$dropdown',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
    },
    VFileInput: {
      variant: 'outlined',
      density: 'comfortable',
      color: 'primary',
      prependIcon: '',
      prependInnerIcon: '$file',
    },
    VCheckbox: {
      color: 'primary',
    },
    VCheckboxBtn: {
      color: 'primary',
    },
    VRadioGroup: {
      color: 'primary',
    },
    VSwitch: {
      color: 'primary',
      inset: true,
    },
    VTabs: {
      color: 'primary',
    },
    VMenu: {
      offset: 6,
    },
    VTooltip: {
      openDelay: 250,
    },
    VAlert: {
      variant: 'tonal',
    },
    VProgressLinear: {
      color: 'primary',
    },
    VProgressCircular: {
      color: 'primary',
    },
    VPagination: {
      rounded: 'circle',
      density: 'comfortable',
      activeColor: 'primary',
    },
    VDataTable: {
      hover: true,
    },
  },
})

export default vuetify
